var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1106.02 634.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eaeded;}.cls-2{fill:#d5dbdb;}.cls-3{fill:#889596;}.cls-4{fill:#b8dde2;}.cls-5{fill:#fff;}.cls-6{fill:#9fcbce;}.cls-7{fill:#fafafa;}.cls-8{fill:#cde6e0;}.cls-9{fill:#b4d1ca;}.cls-10{fill:#eefaf5;}.cls-11{fill:#eff5ed;}.cls-12{fill:#cee0ad;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kettle-desaturated") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kettle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    className: "cls-1",
    d: "M1106,401.13H0s-3.86,163,286.1,163c214,0,381.91,70.42,601.91,70.42S1106,401.13,1106,401.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "echo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "echo-shadow",
    className: "cls-2",
    d: "M562.47,429.56C562.38,435.32,684.75,440,795.22,440s167.2-4.67,167.29-10.43-56.5-10.42-167-10.42S562.56,423.81,562.47,429.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "echo-back",
    className: "cls-3",
    points: "1012.92 155.71 1020.09 155.71 1020.09 418.21 958.21 439.64 1012.92 155.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "echo-front",
    className: "cls-4",
    points: "787.69 155.71 1012.92 155.71 958.21 439.64 732.97 439.64 787.69 155.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "echo-display",
    className: "cls-5",
    points: "785.49 288.76 963.84 288.76 983.67 185.85 805.33 185.85 785.49 288.76"
  }), /*#__PURE__*/React.createElement("g", {
    id: "echo-speaker"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "741.54 431.43 952.8 431.43 976.05 310.81 764.78 310.81 741.54 431.43"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "echo-camera",
    className: "cls-5",
    cx: 896.38,
    cy: 176.07,
    rx: 2.97,
    ry: 2.45,
    transform: "translate(112.67 645.44) rotate(-42.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "echo-bezel",
    className: "cls-5",
    d: "M953,431.72H741.19l.07-.34,51.59-267.75h211.86l-.07.34Zm-211.15-.58H952.57L1004,164.21H793.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "echo-display-text"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M817.5,225.31a10.11,10.11,0,0,0,4.54-1,9.64,9.64,0,0,0,3.44-2.78,10,10,0,0,0,1.88-4.06,5.68,5.68,0,0,0-.78-4.86,5.22,5.22,0,0,0-4.41-1.84,12.27,12.27,0,0,0-5.34,1.39,12.13,12.13,0,0,1,2.66-5.4,5.76,5.76,0,0,1,4.3-1.69,12.85,12.85,0,0,1,2.43.25,9.91,9.91,0,0,1,2.19.64l.74-3.44a7.52,7.52,0,0,0-2.31-.9,12.19,12.19,0,0,0-2.81-.33,10.09,10.09,0,0,0-5.49,1.56,13,13,0,0,0-4.21,4.46,22.65,22.65,0,0,0-2.59,6.87q-1.2,5.55.24,8.34T817.5,225.31Zm-1.31-10.07a9.89,9.89,0,0,1,3.65-.83,2.85,2.85,0,0,1,2.4.91,3,3,0,0,1,.33,2.6q-.78,3.62-4.05,3.61a2.3,2.3,0,0,1-2.44-1.49A9.86,9.86,0,0,1,816.19,215.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M833.93,213.48a3.39,3.39,0,0,0,2.26-.83,3.8,3.8,0,0,0,1.28-2.15,2.57,2.57,0,0,0-.34-2.16,2.25,2.25,0,0,0-1.91-.83,3.41,3.41,0,0,0-2.26.83,3.73,3.73,0,0,0-1.27,2.16,2.56,2.56,0,0,0,.33,2.15A2.26,2.26,0,0,0,833.93,213.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M829.47,224.42a2.26,2.26,0,0,0,1.91.83,3.44,3.44,0,0,0,2.27-.83,3.77,3.77,0,0,0,1.26-2.16,2.52,2.52,0,0,0-.33-2.15,2.25,2.25,0,0,0-1.91-.83,3.41,3.41,0,0,0-2.26.83,3.74,3.74,0,0,0-1.27,2.15A2.57,2.57,0,0,0,829.47,224.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "844.73 224.82 849.48 224.82 854.45 201.84 850.25 201.84 843.36 204.76 842.54 208.54 848.65 206.68 844.73 224.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M867.9,224.34a9.71,9.71,0,0,0,3.57-2.71,9.11,9.11,0,0,0,1.87-3.91,5.72,5.72,0,0,0-.88-5.09,6,6,0,0,0-4.88-1.9,12.25,12.25,0,0,0-2.84.33l1.53-5.44h8.67l.82-3.78H863.15l-2.71,9.85-.65,3a48.51,48.51,0,0,1,5.33-.33,4.15,4.15,0,0,1,3,.85,2.72,2.72,0,0,1,.45,2.63,4.42,4.42,0,0,1-1.61,2.72,5.19,5.19,0,0,1-3.22.93,18.46,18.46,0,0,1-6.08-1.26l-.8,3.71a13.76,13.76,0,0,0,6.27,1.39A11.53,11.53,0,0,0,867.9,224.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M883.86,210.53a14.64,14.64,0,0,0-2.85.28,10.49,10.49,0,0,0-2.5.81l-.42,1.92a15.55,15.55,0,0,1,4.85-.85,2.73,2.73,0,0,1,2.08.6,2.41,2.41,0,0,1,.2,2.08l-.39,1.81a12.38,12.38,0,0,0-3.24-.47,6.58,6.58,0,0,0-4,1.19,5.2,5.2,0,0,0-2.07,3.19,3.43,3.43,0,0,0,.49,3,3.32,3.32,0,0,0,2.77,1.11,6.91,6.91,0,0,0,2.39-.46,9.55,9.55,0,0,0,2.39-1.32l-.1,1.43h2.17l2.15-9.92a3.62,3.62,0,0,0-.48-3.29C886.7,210.88,885.53,210.53,883.86,210.53Zm0,11.19a7.46,7.46,0,0,1-4,1.4,1.73,1.73,0,0,1-1.46-.56,1.89,1.89,0,0,1-.22-1.6c.35-1.59,1.52-2.38,3.52-2.38a10.22,10.22,0,0,1,2.73.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M908.7,213.37a3,3,0,0,1,.07,2l-2,9.42h2.62l2.21-10.19a3.82,3.82,0,0,0-.32-3,2.93,2.93,0,0,0-2.58-1.06,10.65,10.65,0,0,0-5.67,1.94c-.3-1.3-1.27-1.94-2.92-1.94a10.43,10.43,0,0,0-5.34,1.8l0-1.39h-2.2l-3,13.88h2.62l2.36-10.9a8.36,8.36,0,0,1,4.13-1.2,1.49,1.49,0,0,1,1.45.65,3.09,3.09,0,0,1,.07,2l-2,9.42h2.62l2.17-10,.09-.44a3.52,3.52,0,0,0,.07-.41,8.66,8.66,0,0,1,4.16-1.23A1.48,1.48,0,0,1,908.7,213.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "cream-kettle-shadow",
    className: "cls-2",
    d: "M57.51,426.43c0,6.23,177.88,11.28,338.37,11.28s242.81-5,242.81-11.28-82.33-11.28-242.81-11.28S57.51,420.2,57.51,426.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kettle-2",
    "data-name": "kettle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "kettle-top",
    className: "cls-3",
    x: 506.47,
    y: 61.03,
    width: 9.81,
    height: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "kettle-body",
    className: "cls-3",
    d: "M683.68,258.22l-34.56-125c-4.7-17.16-19.77-28.4-35.94-26.71l-11.5,1.31-3.1-24.06a7.3,7.3,0,0,0-6.94-6.17H440.35a7.29,7.29,0,0,0-6.92,6.09L430.06,102h0l-32.83.13a6.71,6.71,0,0,0-5.41,3,9.33,9.33,0,0,0-1.08,8.34L416,178.8,390.91,393.34a33,33,0,0,0,6.44,27.32,26.86,26.86,0,0,0,20.77,10.2H611.76a26.83,26.83,0,0,0,21-10.41,31.85,31.85,0,0,0,5.92-26.77l-10-77.28,37.79-16.86C681.19,292.73,688.41,275.37,683.68,258.22Zm-25.61,23L626,295.55,604.26,127.79l11.1-1.26c6.32-.65,12.22,4.28,14.33,12l34.57,125C666.39,271.29,663.84,278.55,658.07,281.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "kettle-line",
    className: "cls-7",
    points: "600.15 95.99 431.16 95.99 431.35 94.99 600.02 94.99 600.15 95.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mug-shadow",
    className: "cls-2",
    d: "M655.68,468.25c0,1.76-20.16,3.19-73.75,3.19s-120.3-1.43-120.3-3.19,66.71-3.19,120.3-3.19S655.68,466.49,655.68,468.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mug-body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mug-body-container",
    className: "cls-4",
    d: "M587.75,352.54h60A42.23,42.23,0,0,1,690,394.77V470a0,0,0,0,1,0,0H545.52a0,0,0,0,1,0,0V394.77A42.23,42.23,0,0,1,587.75,352.54Z",
    transform: "translate(1235.54 822.5) rotate(180)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "mug-interior",
    className: "cls-6",
    cx: 617.77,
    cy: 352.54,
    rx: 72.25,
    ry: 8.26
  }), /*#__PURE__*/React.createElement("path", {
    id: "mug-handle",
    className: "cls-4",
    d: "M706,376.55a23.52,23.52,0,1,0,23.52,23.51A23.52,23.52,0,0,0,706,376.55Zm-3,33.77c-6.23,0-11.28-4.59-11.28-10.26s5.05-10.25,11.28-10.25,11.28,4.59,11.28,10.25S709.17,410.32,702.94,410.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cream"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cream-package-side",
    className: "cls-8",
    d: "M356.84,196.79,339.7,160.13h.17V149.5a4.7,4.7,0,0,0-4.79-4.61H218a4.7,4.7,0,0,0-4.78,4.61v10.63L232.9,209l-9.81,212.3H352.52a9.87,9.87,0,0,0,10.05-9.67V222.45A60.4,60.4,0,0,0,356.84,196.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cream-package-front",
    className: "cls-9",
    d: "M213.23,160.13l-17.15,36.66a60.54,60.54,0,0,0-5.72,25.66V411.66a9.86,9.86,0,0,0,10,9.67H227a9.87,9.87,0,0,0,10.05-9.67V222.45a60.54,60.54,0,0,0-5.72-25.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cream-labels"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 246.74,
    y: 260.17,
    width: 33.96,
    height: 11.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 246.74,
    y: 277.39,
    width: 108.55,
    height: 17.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 246.47,
    y: 402.6,
    width: 20.96,
    height: 7.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 301.01,
    cy: 337.69,
    rx: 31.25,
    ry: 30.09
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "302.01 144.89 302.13 160.13 323.06 208.14 282.88 208.14 261.95 160.13 261.95 144.89 302.01 144.89"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "cream-fold",
    className: "cls-5",
    x: 213.23,
    y: 159.56,
    width: 126.48,
    height: 1.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "music"
  }, /*#__PURE__*/React.createElement("path", {
    id: "music-eigth-yellow",
    className: "cls-12",
    d: "M855,47.61c-2.45-5.47-14.35,1.9-11.95,7.9l-.2.07,9,24L833.64,94.24,825,71.56c4.34,1.37,11.59-5.84,9.64-10.2-2.46-5.48-14.38,1.92-11.94,7.91l-.18.07L834,99.6l20.85-16.39L845.35,57.8C849.68,59.23,857,52,855,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "music-eighth-yellow",
    className: "cls-8",
    d: "M971.42,90.15,958.27,46,926.79,67.21l10.83,36.85c-6-2.13-16.75,7.17-14.46,13.47,2.89,8,20.44-1.21,17.68-9.92l.48-.14L931.06,72.58,958,54l9.74,32.69c-6-2-16.7,7.22-14.42,13.49,2.9,8,20.49-1.23,17.67-9.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "music-eighth-orange",
    className: "cls-4",
    d: "M805.67,130.23l-6-40.77-30.58,14.75,4.87,34c-5.05-2.65-15.75,4.21-14.53,10.07,1.54,7.42,18.25,1.55,16.92-6.51l.44-.07-4.61-32.2,26.2-13,4.43,30.19c-5.07-2.59-15.71,4.25-14.49,10.09,1.55,7.43,18.29,1.54,16.91-6.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "music-eighth-yellow-2",
    "data-name": "music-eighth-yellow",
    className: "cls-12",
    d: "M704,10.07,671.54,0,651.88,28.26c-1.89-5.39-14.42-7.68-17.53-2.55-3.94,6.5,12.33,13.61,16.85,6.79l.37.26L669.89,6.43,698,14.82,680.88,39.54c-2-5.35-14.42-7.6-17.52-2.49-3.94,6.51,12.36,13.62,16.87,6.76l.34.24ZM670.49,5.56l2-2.85,27.87,8.64L698.55,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "music-quarter-pink",
    className: "cls-8",
    d: "M731.85,97.61l.07,0L715.08,55l-1.7.67L728.69,94.4c-6.33-2.29-17.1,8.61-14.11,15C718.28,117.37,735.53,106.31,731.85,97.61Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckout);
export default __webpack_public_path__ + "static/media/Checkout.7d3158e69144600ce397f0ef50471f00.svg";
export { ForwardRef as ReactComponent };